import React from 'react'

function AllProjects() {
  return (
    <div className='AllProjects'>AllProjects</div>
  )
}

export default AllProjects